import React, { useContext, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from './Modal';
import '../Styles/MenuMobile.scss';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import PasswordChanger from './PasswordChanger';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import {deleteCookie} from '../Util/Cookie';
//import {MenuContext} from '../Contexts/MenuContext';
import { GlobalContext } from '../Contexts/GlobalContext';
import {withRouter} from 'react-router-dom';
import CustomerSite from './CustomerSite';
import TrialWarning from './TrialWarning';
import useGuiTranslations from '../Components/MultiLanguage/useGuiTranslations';

function MenuMobile(props) {
  const classes = useStyles();
  const globalContext = useContext(GlobalContext);
  const [changePasswordOn, setChangePasswordOn] = useState(false);
  const history = useHistory();
  const [translateGui] = useGuiTranslations();

  const setMenu = (menuPath) => {
    closeMenu();
    globalContext.dispatchMethod(
      {
        type: 'SET_MENU_LOCATION',
        value: menuPath,
      }
    )
  }


  const closeMenu = ()=> {
    if (props.closeMenu) {
      props.closeMenu();
    }
  }

  const signOut = () => {
    //delete cookie or set the expiry time to zero
    deleteCookie();
    closeMenu();
    //and send the log on
    //window.location = '/Login';
    history.push('/Login');

  }
  
  return (
    <React.Fragment>
      {(props.location.pathname != '/Login' && props.location.pathname != '/') ?
      <div className="menu-mobile">
        <div style={{ display: 'flex', justifyContent: 'flex-end' , position: 'fixed',
    width: '100%' }}>

          <i onClick={props.closeMenu} className="material-icons menu-close-button">close</i>
        </div>

        
        <div className="menu-header">
          <Typography variant="button" display="block" gutterBottom>
            {translateGui(1)}
        </Typography>
        </div>
        <div className="menu-line">
          <Link id="menuOpenOrders" className={globalContext.globalState.menuLocation.a == 'Open Orders' ? classes.blueMenuItem : null}  onClick={props.closeMenu} color="secondary" component={RouterLink} to={'/OpenOrders'} >
            <i className="material-icons">notification_important</i>
            <span>{translateGui(2)}  </span>
          </Link>
        </div>
        <div className="menu-line">
          <Link color="secondary" className={globalContext.globalState.menuLocation.a == 'Order History' ? classes.blueMenuItem : null}  onClick={props.closeMenu} component={RouterLink} to={'/OrderHistory'} >
            <i className="material-icons">history</i>
            <span>{translateGui(3)}</span>
          </Link>
        </div>
        <div className="menu-line">
          <Link color="secondary" className={globalContext.globalState.menuLocation.a == 'Order History' ? classes.blueMenuItem : null}  onClick={props.closeMenu} component={RouterLink} to={'/UnpaidOrders'} >
            <i className="material-icons">money_off</i>
            <span>{translateGui(109)}</span>
          </Link>
        </div>

        <div className="menu-header">
          <Typography variant="button" onClick={props.closeMenu} display="block" gutterBottom>
            {translateGui(4)}
          </Typography>
        </div>
        <div className="menu-line">
          <Link id="menuCategories" className={globalContext.globalState.menuLocation.a == 'Categories' ? classes.blueMenuItem : null}  onClick={props.closeMenu} color="secondary" component={RouterLink} to={'/Categories'} >
            <i className="material-icons">category</i>
            <span>{translateGui(5)}</span>
          </Link>
        </div>
        <div className="menu-line">
          <Link color="secondary" className={globalContext.globalState.menuLocation.a == 'Food & Drinks' ? classes.blueMenuItem : null}  onClick={props.closeMenu} component={RouterLink} to={'/FoodAndDrinks2'} >
            <i className="material-icons">fastfood</i>
            <span>{translateGui(6)}</span>
          </Link>
        </div>
        <div className="menu-line">
          <Link color="secondary" className={globalContext.globalState.menuLocation.a == 'Option Groups' ? classes.blueMenuItem : null}  onClick={props.closeMenu} component={RouterLink} to={'/OptionGroupsList'} >
            <i className="material-icons">rule</i>
            <span>{translateGui(7)}</span>
          </Link>
        </div>
        <div className="menu-header">
          <Typography variant="button" display="block" gutterBottom>
          {translateGui(8)}
          </Typography>
        </div>
        <div className="menu-line">
          <Link color="secondary" className={globalContext.globalState.menuLocation.a == 'Payment Configuration' ? classes.blueMenuItem : null}  onClick={props.closeMenu} component={RouterLink} to={globalContext.globalState.customerSettings.country == 'TR' ? '/PaynetConfiguration' : '/Payment__Configuration'}>
            <i className="material-icons">settings_applications</i>
            <span>{translateGui(9)}</span>
          </Link>
        </div>
        <div className="menu-line">
          <Link color="secondary" className={globalContext.globalState.menuLocation.a == 'Tables' ? classes.blueMenuItem : null}  onClick={props.closeMenu} component={RouterLink} to={'/Tables'} >
            <i className="material-icons">restaurant</i>
            <span>{translateGui(10)}</span>
          </Link>
        </div>
        <div className="menu-line">
          <Link color="secondary" className={globalContext.globalState.menuLocation.a == 'Company Info' ? classes.blueMenuItem : null} onClick={props.closeMenu} component={RouterLink} to={'/Logo'} >
            <i className="material-icons">mms</i>
            <span >{translateGui(11)}</span>
          </Link>
        </div>
        <div className="menu-line">
          <Link color="secondary" className={globalContext.globalState.menuLocation.a == 'Deliver & Collect' ? classes.blueMenuItem : null}  onClick={props.closeMenu} component={RouterLink} to={'/Settings/DeliverAndCollect'} >
            <i className="material-icons">two_wheeler</i>
            <span>{translateGui(12)}</span>
          </Link>
        </div>
        
        <div className="menu-line">
          <Link color="secondary" className={globalContext.globalState.menuLocation.a == 'Subscription' ? classes.blueMenuItem : null}  onClick={props.closeMenu} component={RouterLink} to={'/AdvancedSettings'} >
            <i className="material-icons">settings</i>
            <span>{translateGui(13)}</span>
          </Link>
        </div>

        <div className="menu__mobile-user">
          <div className="menu-header">
            <Typography variant="button" display="block" gutterBottom>
            {translateGui(14)}
            </Typography>
          </div>
          <div className="menu-line">
            <Link color="secondary" className={globalContext.globalState.menuLocation.a == 'Logo' ? classes.blueMenuItem : null}  onClick={() => setChangePasswordOn(true)}>
              <i className="material-icons">restaurant</i>
              <span>{translateGui(15)}</span>
            </Link>
          </div>
          <div className="menu-line">
            <Link color="secondary" onClick={signOut}>
              <i className="material-icons">mms</i>
              <span>{translateGui(16)}</span>
            </Link>
          </div>
        </div>
        <TrialWarning closeMenu={closeMenu}></TrialWarning>
        <CustomerSite></CustomerSite>
        {changePasswordOn ?
        <Modal viewModal={setChangePasswordOn}>
          <PasswordChanger></PasswordChanger>
        </Modal>
        : null}

      </div>
      : null
      }
    </React.Fragment>
  );
}
const useStyles = makeStyles({
  blueMenuItem: {
    color: '#069cff',
    '& span': {
      //borderBottom: '1px solid',
    }
  },
});

export default withRouter(MenuMobile);
